import { t } from '../../../../services/i18nService';

const playTestSoundButtonSelector = {
    selectLabel() {
        return t('hardwareAccessCheck.playTestSound');
    },

    computeProps() {
        return {
            label: this.selectLabel(),
        };
    },
};

export default playTestSoundButtonSelector;
